export default {
  all: 'All',
  back: 'Back',
  searchResults: 'Search Results',
  searchPlaceholder: 'Search',
  apply: 'Apply',
  clearAll: 'Clear all',
  addResourceToPlayable: {
    editInfo: ['Current update operation, no node selected', 'Game not loaded'],
    editError: [
      'Add Failed',
      'Each scene supports up to 4 videos',
      'The asset has been deleted, please select again',
    ],
  },
  audioList: {
    deleteError: 'Failed to delete',
  },
  audioUploader: {
    localUpload: 'Upload',
    uploadRule: ['Upload sound effects can only be', 'Format!', 'Exceed'],
    tips: 'Browse all assets',
    uploadRuleTips: {
      format: 'Audio Format',
      fileSize: 'Audio file size',
    },
  },
  deleteResource: {
    deleteError: 'Failed to delete',
  },
  dialog: {
    image: 'My Picture',
    aImage: 'My Motion Graphic',
    xlz: 'My sequence frame',
    text: 'Text',
    video: 'Video',
    audio: 'My Audio',
    bgm: 'My BGM',
    particleEffect: 'Particle',
    assetLibrary: 'My Assets',
    tips: 'Only show assets that meet the current formatting requirements',
  },
  imageUploader: {
    uploadRule: [
      'Upload pictures can only be',
      'Format!',
      'Exceed',
      'Image can not Exceed xxx, Please try again after modify.',
    ],
    uploadRuleTips: {
      format: 'Images Format',
      fileSize: 'Image file size',
    },
  },
  resource: {
    noFoundError: 'The name must end with a number',
  },
  textList: {
    gameNotLoad: 'Game not loaded',
  },
  videoUploader: {
    uploadRule: ['Upload video can only be', 'Format!', 'Exceed'],
    sceneSupport: 'Each scene supports up to 4 videos',
    uploadRuleTips: {
      format: 'Video file format',
      fileSize: 'Video file size',
    },
  },
  xlzUploader: {
    exceed: 'Exceed',
    addXlzError: 'Failed to add sequence frame, please try again later',
  },
  emptyNodeCategory: {
    label: 'Interactive Area',
    text: 'Interactive Area',
  },
  dragonBone: {
    required:
      'The Json file only allows three files: **_ske.json, **_tex.json, **_tex.png, ** must be consistent',
  },
  categoryList: {
    commonLib: {
      label: 'Pub',
      text: 'Pub',
    },
    assetLib: {
      label: 'My Assets',
      text: 'My Assets',
    },
    resourcePool: {
      label: 'ResourcePool',
      text: 'ResourcePool',
    },
    image: {
      label: 'Images',
      text: 'Images',
      commonImage: 'Images Lib',
    },
    aImage: {
      label: 'Motion Graphic',
      text: 'Motion Graphic',
      commonImage: 'Motion Graphic Lib',
    },
    video: {
      label: 'Video',
      text: 'Video',
    },
    audio: {
      label: 'Sound Effects',
      text: 'Sound Effects',
      commonAudio: 'Audio Lib',
    },
    text: {
      label: 'Text',
      text: 'Text',
    },
    bgm: {
      label: 'BGM',
      text: 'BGM',
      commonBgm: 'BGM Lib',
    },
    effect: {
      label: 'Particle',
      text: 'Particle',
      myEffect: 'My Animation',
      xlzUploaderTitle: 'Import Sequence',
      xlzUploaderTips: 'Please select a set of images',
      dragonUploaderTitle: 'Import .Json File',
      dragonUploaderTips: 'Support Zip(json+png) Format',
      xlzTxt: 'Sequence',
      particlesTxt: 'Particles',
      dragonTxt: 'DragonBones',
    },
    scene: {
      label: 'Presets Library',
      text: 'Presets Library',
    },
    quickLayout: {
      label: 'Quick layout',
      text: 'Quick layout',
    },
    playUnit: {
      label: 'Gameplay Template',
      text: 'Gameplay Template',
    },
    widgetLib: {
      label: 'Component',
      text: 'Component',
    },
    globalVar: {
      label: 'Global variables',
      text: 'Global variables',
      addBtn: '+ Add variables',
      addTitle: 'New variable',
      editTitle: 'Edit variable',
      key: 'Name',
      varType: 'Variable Type',
      initValue: 'Initial value',
      desc: 'Description',
      keyPlaceholder: 'Enter variable name',
      varTypePlaceholder: 'Select data type',
      initValuePlaceholder: 'Select variable type first',
      initNumberPlaceholder: 'Enter initial value',
      initStringPlaceholder: 'Enter initial text content',
      initBooleanPlaceholder: 'Select initial value',
      descPlaceholder: 'Enter description (optional)',
      typeNumber: 'Value',
      typeString: 'Text',
      typeBoolean: 'Boolean',
      typeGlobalVar: 'Global variables',
      cancelBtn: 'Cancel',
      saveBtn: 'Save',
      confirmBtn: 'Confirm',
      trueValue: 'true',
      falseValue: 'false',
      errorTip: 'Required fields',
      errorTip2: 'Should not start with number',
      errorTip3: 'Global variables cannot have duplicate names',
      errorTip4: 'playsmartGlobalVars is system reserved words',
      errorTip4_2: 'timers is system reserved words',
      errorTip5:
        'Only English, Chinese, numbers and underscores are supported, and should not exceed 20 characters in total',
      errorTip6: 'Description cannot exceed 50 characters',
      deleteGlobalVarConfirm:
        'The global variable has been linked to an event. Deleting it will also delete the corresponding event. Please confirm whether to make the deletion!',
      globalVarWarning: 'Warning',
      editGlobalVarTypeConfirm:
        'The global variable has been linked to an event. Changing the variable type will delete the corresponding event. Please confirm whether to make the change!',
      editGlobalVarKeyConfirm:
        'The global variable has been linked to an event. Changing the variable name will delete the corresponding event. Please confirm whether to make the change!',
      noDataTip: 'No Data',
      noDataTip2: 'Click the button to add global variables',
      conditionCompare: 'Condition',
      addConditionCompare: '+ Add conditions',
      globalVarKeyPlaceholder: 'Global variable',
      compareTypePlaceholder: 'Types',
      compareValuePlaceholder: 'Type first',
      compareValueNumberPlaceholder: 'Value',
      compareValueStringPlaceholder: 'Text',
      compareValueBooleanPlaceholder: 'Boolean',
      compareValueGlobalVarPlaceholder: 'Global variable',
      compareTipIf: 'If',
      compareTipAnd: 'and',
      onlyOnce: 'Valid only once',
      selectComputeMethod: 'Select operation method',
      deleteCompareWarning:
        'Deleting this condition will also delete the corresponding response event. Please confirm whether to make the deletion!',
    },
  },
  confirm: 'Confirm',
  dragUpload: {
    note: 'Drag and drop files to upload instantly',
    fileRequired: 'Supported file formats: png/jpg/mp3/mp4/Json zip(json+png)',
    namedRequired:
      'Sequence upload naming requirement example: explosion 1.png explosion 2.png explosion 3.png (provided frame by frame)',
  },
  assetLib: {
    PublicAssetLib: 'Public Assets',
    MyAssetLib: 'My Assets',
    image: 'Images',
    gif: 'Motion Graphic',
    bgm: 'BGM',
    soundEffect: 'Sound Effects',
    particle: 'Particle',
    video: 'Video',
    audio: 'Audio',
  },
}
